/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2019/11/15 16:43
 */
export { ORDER_SOURCE as SHOP_TYPE }

export enum ORDER_SOURCE { // 需要反向引用，所以不用 const
  WOO_COMMERCE = 1,
  SHOPIFY,
  BUCKY_SHOP,
  BUCKY_DROP, // 备货订单
  OTHERS,
  CO_WORKERS,
}

export const enum UP_AND_DOWN {
  UP = 1, // 上架
  DOWN = 2 // 下架
}

export const enum SHOP_STATUS {
  NORMAL, // 正常
  DEACTIVATE, // 只有BS才有的状态，进行Deactivate操作，停用
  EXPIRED, // 只有BS才有的状态,过期
}

/**
 * SO 单业务类型
 * 1：销售单业务（可以拆单成供应商po单、采购po单，库存po单）
 * 2：备货单业务(可以拆单成供应商po单、采购po单、转运po单)
 */
export const enum SO_ORDER_TYPE {
  SALE_ORDER = 1, // 销售单业务
  STOCK_ORDER, // 备货单业务
}

// PO 订单类型
export const enum PO_ORDER_TYPE {
  SUPPLIER = 1, // 供应商po单
  PURCHASE, // 代购po单
  TRANSPORT, // 转运po单
  STOCK, // 库存po单
}

// 转运订单类型
export const enum ORDER_TRANSPORT_TYPE {
  STOCK_UP = 1, // 库存转运单
  SERVICE, // 服务转运单
}

export const enum GOODS_BUSINESS_TYPE {
  BUYING_BEHALF = 1,
  SELF_SUPPORT,
  THIRD_PARTY,
  COOPERATION,
  STOCK_UP,
  SELF_STOCK_UP = 7,
}

/**
 * 订单状态
 * // 9. 已入库状态，如果入库时间超过五天，需要显示"入库超过五天的提示"
 +--------------+----------+--------------+----------------+
 |              |          | 列表筛选状态    | 列表筛选状态   |
 +--------------+----------+--------------+------------===-+
 | PO列表        | 全部      | 无           | 1.待审核       |
 |              |          |              | 2.待接单        |
 |              |          |              | 3.待订购，已接单 |
 |              |          |              | 4.待确认        |
 |              |          |              | 5.待订购        |
 |              |          |              | 6.待发货        |
 |              |          |              | 7.待签收        |
 |              |          |              | 8.待入库，已签收 |
 |              |          |              | 9.已入库        |
 |              |          |              | 10.已取消       |
 |              +----------+--------------+----------------+
 |              | 进行中    | 非已入库       | 无            |
 |              +----------+--------------+----------------+
 |              | 等待提包   | 已入库        | 无            |
 +--------------+----------+--------------+----------------+
 | 正常包裹列表   | 正常类型   | 无           | 1.待出库      |
 |              |          |              | 2.已出库       |
 |              |          |              | 3.待签收       |
 |              |          |              | 4.已完成       |
 |              |          |              | 5.已取消       |
 +--------------+----------+--------------+---------------+
 | 异常包裹列表   | 异常类型   | 无           | 1.待退回      |
 |              |          |              | 2.已退回       |
 |              |          |              | 3.已关闭       |
 +--------------+----------+--------------+----------------+
 | 退换货申请列表             | 无           | 1.待审核      |
 |                         |              | 2.审核通过     |
 |                         |              | 3.审核不通过   |
 +-------------------------+--------------+---------------+
 */
export const enum SHOW_STATUS {
  APPROVED_WAIT = 1,
  PENDING_RECEIPT,
  CONFIRM = 4,
  STAY_ORDER,
  STAY_DELIVERY,
  SHIPPED,
  ARRIVED,
  STOCKED,
  CANCELED,
}

// 订单的拆单原因
export const enum ORDER_DIVISION_TYPE {
  NORMAL,
  SHORT_DELIVERY, // (1, "少货"),
  PRODUCT_DEFECT, // (2, "瑕疵"),
  USER_REQUIREMENT, // (3, "用户要求");
}

// 异货过程中发现商品有瑕疵，瑕疵的类型
export const enum DEFECT_TYPE {
  SMALL = 1, //  微小瑕疵
  // MIDDLE, // 一般瑕疵
  LARGE = 3, // 重大瑕疵
  PRODUCT_MISSING,
}

// 支付状态
export const enum PAY_STATUS {
  NO_PAID, // 订单未支付
  PAID, // 订单已支付
  REFUNDED, // 已退款
  COMPLETE, // 交易完成
}

// 不同处理状态的订单类型，对应 SO 单页面的三个标签页
export const enum ORDER_TAB_TYPE {
  ALL_ORDERS = 1,
  PROCESSING,
  AWAITING_DELIVERY,
  FAILED, // 自动提交包裹失败列表
}

// 商品过期状态
export const enum OVERDUE_STATUS {
  NORMAL = 1,
  EXPIRED,
  DESTROYED,
}

// 套餐资产状态
export const enum PLAN_EFFECT_STATE {
  NOT_EFFECTIVE, // 未生效
  EFFECTIVE, // 生效
  REFUNDED, // 已退款
  EXPIRED, // 已失效
}

// 服务套餐上下架状态
export const enum SALE_STATE {
  UP,
  DOWN
}

// 商品推送状态
export const enum PRODUCT_PUSH_STATE {
  PENDING, // 等待中(MQ发送端)
  CREATING, // 创建中(MQ消费端)
  COMPLETED, // 创建完成
  FAILED// 创建失败
}

// 商品备货状态，
export const enum PRODUCT_INVENTORY_STATE {
  FALSE, // 未备货
  TRUE, // 已备货
}

export const enum ORDER_POOL_TYPE {
  STORE_ORDER = 1, // 店铺订单
  MANUAL_ORDER// 手动创建订单
}

export const enum ORDER_POOL_STATUS {
  FAILED, // 自动提单失败
  UN_PUSHED, // 未推送
  PUSHED, // 已推送
  CANCELED, // 已取消
  PART_PUSHED // 部分推送
}

export enum PLATFORM {
  ALIBABA = 'ALIBABA',
  AMAZON = 'AMAZON',
  BUCKY_DROP = 'BUCKYDROP',
  CUSTOMIZE = 'CUSTOMIZE',
  DD = 'DD',
  JD = 'JD',
  JHS = 'JHS',
  STOCK = 'STOCK',
  TB = 'TB',
  TMALL = 'TMALL',
  VIP = 'VIP',
  YH = 'YH',
  PP = 'PP'
}

// 补款时，商品款项之外的补款
export const enum OTHER_SUPPLEMENT_TYPE {
  FREIGHT_CHARGE = 1, // 运费
  SERVICES_CHARGE, // 服务费
  OTHERS, // 其它费用
}

// 显示商品信息确认弹窗，还是商品补款弹窗
export const enum ORDER_MODAL_VISIBLE_TYPE {
  FILL_ACCOUNT_MODAL,
  PRODUCT_INFO_CONFIRM_MODAL
}

// 服务类型
export const enum ASSEMBLE_TYPE {
  SO = 'SO', // SO 单相关的服务
  PO = 'PO', // PO 单相关的服务
  PR = 'PR', // 商品相关的服务
  PA = 'PA', // 包裹相关的服务
  SKU_QTY = 'SKU_Qty', // 商品相关的服务，以某个数量的 sku 为使用单位
}

// 使用服务时，提交生成服务订单的方式，是在弹窗内部提交生成服务订单，还是由外部自行处理
export const enum SERVICE_SUBMIT_MODE {
  INNER,
  OUTSIDE
}

// 服务订单的状态
export const enum SERVICE_ORDER_STATE {
  WAITING_PAY = 'WAITING_PAY', // 待支付
  PAID = 'PAID', // 已支付
  SUCCESS = 'SUCCESS', // 完成服务
  REJECT = 'REJECT', // 服务单退单
  PROCESSING = 'PROCESSING', // 处理中
}

export enum REMINDER_ASSETS_CODE {
  BUCKY_SHOP = 'DPFWBS01', // BS店铺数量
  CONNECT_SOURCE = 'SPFWHY02', // 货源绑定
  OTHER_SHOP = 'DPFWTH02', // 其他平台店铺数量
  PRODUCT_PUSH = 'SPFWTS03', // 商品推送
  LOGISTICS_TRACKING = 'AS655781265', // 包裹物流轨迹查询
  TRANSLATE = 'SPFWFY01', // 翻译
}

// 仓库签收状态 1:未签收 2:客户已签收
export const enum SIGN_STATUS {
  UN_SIGNED = 1,
  SIGNED
}

// 系统版本
export const enum EDITION {
  STANDARD, // 标准版
  PROFESSIONAL, // 专业版
}

export const enum FEEDBACK_STATE {
  TO_BE_REPLY, // 待处理
  PROCESSING, // 处理中
  COMPLETED, // 已完成
}

export const enum ACCOUNT_TYPE {
  MAIN_ACCOUNT = 1,
  STAFF_ACCOUNT,
  AGENCY_ACCOUNT,
}

// 账号是否从旧系统迁移过来的
export const enum TRANSFER_STATUS {
  UN_TRANSFERRED,
  TRANSFERRED,
}

export const enum SERVICE_TYPE {
  ORDER = 'order',
  PACKAGE = 'package',
}

// 推送订单时，批量入库还是零散入库
export const enum IN_STORAGE_MODE {
  BATCH,
  SINGLE,
}

// 生成的订单，是否加入待合并提交包裹列表
export const enum MERGE_PARCEL_MODE {
  NO,
  YES
}

export const enum STORAGE_ITEM {
  ACCOUNT_TYPE = 'account_type',
  AGENT_CODE = 'agent_code',
  BALANCE_TIP_VISIBLE_CLOSE_TIME = 'balance_tip_visible_close_time',
  BUCKY_DROP_SHOP_ID = 'bucky_drop_shop_id', // 店铺订单页，记住当前用户选择的店铺
  CONNECT_THIRD_PARTY_SHOP = 'connect_third_party_shop', // 注册后，选择绑定 Shopify 或者 WooCommerce，拉往建店页，根据 storage 打开对应弹窗
  HIDE_INFLUENCER_PLAN_BANNER = 'hide_influencer_plan_banner',
  INFLUENCER_PLAN_MODAL = 'influencer_plan_modal',
  MERGED_PARCELS_COUNT = 'merged_parcels_count',
  NO_LONGER_PROMPT_UPDATE = 'no_longer_prompt_update',
  PROMOTION_ALLIANCE_CODE = 'promotion_alliance_code',
  REFUNDING_CHANGING_AGREEMENT = 'refunding_changing_agreement',
  SAVED_PRODUCTS = 'saved_products',
  GUIDE_SELECT_VALUE = 'guide_select_value', // 新手引导选择的指引方式
  STOP_IN_NEW_USER_GUIDE = 'stop_in_new_user_guide', // 是否停留在新用户的引导页
  SHOW_WOOCOMMERCE_NOT_SUPPORT_SEARCH = 'show_woocommerce_not_support_search', // Product List，Shopify 商品不支持模糊搜索和跨页查询，显示提示
  SERVER_TIME = 'server_time',
  TAG_POINT = 'tag_point',
  READED_POLICY = 'readed_policy', // 是否阅读过用户隐私协议，对象中存数组，每一项是一个账号
}

// 谷哥事件的用法，详见 docs/Google Analytics Event.md
export const enum HTAG {
  ADMIN_3PARTY_BANNER = 'admin_3party_banner', // 第三方平台商品页面轮播 Banner
  ADMIN_3PARTY_HOT = 'admin_3party_hot', // 第三方平台商品页面搜索框下面的商品分类
  ADMIN_3PARTY_POPUP = 'admin_3party_popup', // 第三方平台商品页面中的查看供应商商品链接
  ADMIN_GYS_BANNER = 'admin_gys_banner', // 供应商商品页面轮播 Banner
  ADMIN_GYS_HOT = 'admin_gys_hot', // 供应商商品页面搜索框下面的商品分类
  ADMIN_GYS_JXPP = 'admin_gys_jxpp', // 供应商商品页面品版列表
}

export const enum PATH_STATE {
  CREATE_MANUAL_ORDER = 'create_manual_order',
}

export enum REQUIRED_PACKAGE_SERVICES {
  BAG = 'AS347767713', // 袋装
  CARTON = 'PACP0003', // 纸箱装
}

/**
 * S001(7,"S001","产研服务"),
 * S002(7,"S002","咨询服务"),
 * S003(7,"S003","运营服务"),
 * S004(7,"S004","下单服务"),
 * S006(7,"S006","入库服务"),
 * S008(7,"S008","包裹服务"),
 * S010(7,"S010","商品服务"),
 * S005(1,"S005","采购服务"),
 * S007(2,"S007","仓储服务"),
 * S009(3,"S009","代运营服务"),
 * S011(4,"S011","商品信息服务"),
 * S012(5,"S012","物流服务"),
 * S013(5,"S013","保管期服务"),
 * ShopRenewal(6,"ShopRenewal","店铺续费");
 */
export const enum SERVICE_CATEGORY { // 增值服务类目
  INSPECTION = 'S014',
  PACKING = 'S008',
}

export const enum PRODUCTS_APPLY_MODULE {
  BS_CREATE_STORE = 1, // BS建店预置
  BD_RECOMMEND_PRODUCTS = 2, // BD推荐商
  OTHER = 9, // 其他
}

// 备货权限 默认值0 无0 有1
export const enum INVENTORY_PERMISSION {
  REFUSE,
  ALLOW
}

// 第三方店铺商品的绑定关系情况
export const enum THIRD_GOODS_STATUS {
  ALL = '1',
  PART = '2',
  ALL_NO = '3'
}
